const WORKSPACE_CRYPTO_KEY_BASE = 'workspace-crypto';
const DECRYPT = 'decrypt';
export const WorkspaceCryptoKeyFactory = {
    all: (workspaceId) => [
        WORKSPACE_CRYPTO_KEY_BASE,
        workspaceId,
    ],
    decrypt: (workspaceId, encryptedValue) => [
        ...WorkspaceCryptoKeyFactory.all(workspaceId),
        DECRYPT,
        encryptedValue,
    ],
};
